<script setup lang="ts">
import { api } from '@/api';
import { type UpdateSiteNameRequestDto } from '@/api/generator';
import PtwCancelButton from '@/components/buttons/PtwCancelButton.vue';
import VeeSubmitButton from '@/components/forms/SubmitButton/VeeSubmitButton.vue';
import { useVeeForm } from '@/components/forms/useVeeForm';
import InstallationName from '@/components/InstallationName/InstallationName.vue';
import BasePage from '@/components/pages/BasePage/BasePage.vue';
import BasePageTitle from '@/components/pages/BasePage/BasePageTitle.vue';
import { formBackendErrorHandler } from '@/errorHandling';
import { routenames } from '@/router/routenames';
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

const { form } = useVeeForm<UpdateSiteNameRequestDto>({
  schemaName: 'UpdateSiteNameRequestDto',
  mode: 'edit',
});

const { handleSubmit, resetForm } = form;

const submit = handleSubmit(async (updateSiteNameRequestDto) => {
  const { success } = await api.installApi.updateSiteName(
    {
      updateSiteNameRequestDto,
    },
    [formBackendErrorHandler(form)],
  );
  if (success) {
    await router.push({ name: routenames.settings });
  }
});

onMounted(async () => {
  const { success, result } = await api.installApi.getInstallationConfig();
  if (success && result?.customerProvidedOptionalSiteName) {
    resetForm({
      values: {
        customerProvidedOptionalSiteName: result.customerProvidedOptionalSiteName,
      },
    });
  }
});
</script>

<template>
  <form @submit="submit">
    <BasePage>
      <template #title>
        <BasePageTitle :title="$t('InstallationName')" />
      </template>

      <template #actions>
        <PtwCancelButton :to="{ name: routenames.settings }" />
        <VeeSubmitButton class="ml-2" :text="$t('Save')" />
      </template>

      <v-sheet class="pa-4">
        <InstallationName class="w-lg-50" />
      </v-sheet>
    </BasePage>
  </form>
</template>

<style lang="scss" scoped>
.step-content {
  padding-bottom: var(--v-footer-height);
}
</style>
